module.exports = __webpack_public_path__ + "static/media/logo-오픈엣지@2x.6ea896bb.png";